module.exports = __webpack_public_path__ + "img/bnkj.00a81fab.png";